import { render, staticRenderFns } from "./mgrStudentProgressEdit.vue?vue&type=template&id=2e993e4a&scoped=true&"
import script from "./mgrStudentProgressEdit.vue?vue&type=script&lang=js&"
export * from "./mgrStudentProgressEdit.vue?vue&type=script&lang=js&"
import style0 from "./mgrStudentProgressEdit.vue?vue&type=style&index=0&id=2e993e4a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e993e4a",
  null
  
)

export default component.exports